import { useTranslations } from 'next-intl';
import { Fragment } from 'react';
import { Link } from 'react-scroll';

import { useBySize } from '@/hooks/useBySize';

import { NodeItemId } from './BlogPostScreen.utils';

interface Props {
  headers: NodeItemId[];
}

export const BlogPostShortContent = (props: Props) => {
  const t = useTranslations();
  const { headers } = props;
  const offset = useBySize({
    mobile: -16,
    laptop: -72,
  });
  return (
    <div className="sticky top-20">
      <span className="mb-2 inline-flex text-body-l font-bold laptop:mb-4">{t('blogPost.short')}</span>
      <ul className="divide-y divide-grey-300">
        {headers.map((header) => (
          <Fragment key={header.id}>
            <li className="block">
              <Link
                to={header.id}
                smooth
                href={`#${header.id}`}
                duration={200}
                offset={offset}
                spy
                className="flex p-2 text-body-l text-blue-700 hover:underline"
              >
                {header.text}
              </Link>
            </li>
            {header.subheadings?.map((subheader) => (
              <li key={subheader.id}>
                <Link
                  to={subheader.id}
                  smooth
                  href={`#${subheader.id}`}
                  duration={200}
                  offset={-72}
                  spy
                  className="flex p-2 pl-8 text-body-l text-blue-700 hover:underline"
                >
                  {subheader.text}
                </Link>
              </li>
            ))}
          </Fragment>
        ))}
      </ul>
    </div>
  );
};
